export const documentationCard = {
  readModalTitle: 'Dokumentation herunterladen',
  updateModalTitle: 'Dokumentation aktualisieren',
  updateModalButtonText: 'Aktualisieren',
  deleteModalTitle: 'Sind Sie sicher, dass sie Ihre Dokumentation löschen möchten?',
  deleteModalButtonText: 'Löschen',
  titlePlaceholder: 'Titel',
  notePlaceholder: 'Notiz',
  fileDownloadFailedErrorMessage: 'Datei konnte nicht heruntergeladen werden.',
  updateDocumentationErrorMessage: 'Dokumentation konnte nicht aktualisiert werden.',
  deleteDocumentationErrorMessage: 'Dokumentation konnte nicht gelöscht werden.',
  missingTitleErrorMessage: 'Es muss ein Titel für die Dokumentation angegeben werden.',
}
